import { create } from "zustand";

interface DetailsSidebarState {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

export const useDetailsSidebarState = create<DetailsSidebarState>((set) => ({
  isCollapsed: false,
  onToggleCollapse: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
}));
